/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation, useParams  } from "react-router-dom";
import { ALL_MAIL_LISTING_URL } from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import CommonReactSelectMenu from "../../Common/CommonReactSelectMenu";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
import CommonScrollBar from "../../Common/CommonScrollBar";
import CommonToggle from "../../Common/CommonToggle";
import { EventOptions } from "../../../Dummy";

const UpdateMail = () => {
    const Dispatch = useDispatch();
    const Navigate = useNavigate();
    const LocationRoute = useLocation()?.pathname?.split("/")[1];
    const { websocket } = useContext(WebSocketContext);
    const [ ApplicationState, setApplicationState ] = useState({
        SubjectName: "",
        To: [],
        Cc: [],
        Body: "",
        Status: true,
    });
    const [ SelectEvent, setSelectEvent ] = useState("");
    const [ focused, setFocused ] = useState(false);
    const { roomId } = useParams();
    const { ClearFormSet, MailListing, device_id } = useSelector((state) => state.adminReducers);
    const CurrentData_ = MailListing?.list?.filter((elm) => elm?.id === roomId)[0];

    // editor code
    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link"
    ];
    const modules = {
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" }
          ],
          ["link"],
          ["clean"]
        ]
    }; 

    // error state
    const [ errorSubjectName, seterrorSubjectName ] = useState("");
    const [ errorSelectEvent, seterrorSelectEvent ] = useState("");
    const [ errorToEmail, seterrorToEmail ] = useState("");
    const [ errorCcEmail, seterrorCcEmail ] = useState("");
    const [ errorMailFormat, seterrorMailFormat ] = useState("");

    useEffect(() => {
        if(LocationRoute === "update-mails") {
            UpdateDataPopulate(CurrentData_);
        };
    }, [ CurrentData_ ]);

    const UpdateDataPopulate = (current_details) => {
        const { et_subject, et_to, et_cc, et_body, is_active, et_event } = current_details;

        setApplicationState({
            ...ApplicationState,
            SubjectName: et_subject,
            To: et_to?.split(","),
            Cc: et_cc?.split(","),
            Body: et_body,
            Status: is_active,
        });
        setSelectEvent(EventOptions?.find((elm) => elm?.value === et_event));
    };

    // last key code check and remove value
    const ValueKeyPress = (e) => {
        const code = e.keycode || e.which;
        if(code === 8 && e.target.innerHTML === "<p><br></p>") {
            setApplicationState({
                ...ApplicationState,
                Body: ""
            });
        };
    };

    // get editor data
    const GetBodyEditor = (data) => {
        if(data !== "<p><br></p>") {
            setApplicationState({
                ...ApplicationState,
                Body: data
            });
            CheckValid(data, {type: 'MailFormat', error: seterrorMailFormat});
        } else {
            setApplicationState({
                ...ApplicationState,
                Body: ""
            });
            CheckValid("", {type: 'MailFormat', error: seterrorMailFormat});
        };
    };

    // onChange To and Cc email
    const onChangeToEmail = (_emails, url) => {
        if(url === "to_email") {
            setApplicationState({
                ...ApplicationState,
                To: _emails,
            });
            CheckValid(_emails, {type: 'ToEmail', error: seterrorToEmail});
        } else {
            setApplicationState({
                ...ApplicationState,
                Cc: _emails,
            });
            CheckValid(_emails, {type: 'CcEmail', error: seterrorCcEmail});
        };
    };

    // Update mail functions
    const ValidToMail = Array.isArray(ApplicationState?.To) && ApplicationState.To?.toString()?.length > 0 && ApplicationState.To?.toString()?.length <= 500;
    const ValidCCMail = Array.isArray(ApplicationState?.Cc) && ApplicationState.Cc?.toString()?.length > 0 && ApplicationState.Cc?.toString()?.length <= 500;
    
    const UpdateMailFunctions = () => {
        if(ApplicationState?.SubjectName.trim() !== "" && SelectEvent !== "" && ValidToMail && ValidCCMail &&  ApplicationState?.Body !== "") {
            Dispatch(ClearFormSetFutios({
                url: LocationRoute === "update-mails" ? "email_template_edit" : "email_template_add",
                action: true
            }));
            let param = { 
                "transmit": "broadcast", 
                "request" : { 
                    "et_subject" : ApplicationState?.SubjectName.trim(),
                    "et_event" : SelectEvent?.value,
                    "et_to" : ApplicationState?.To?.toString(),
                    "et_cc" : ApplicationState?.Cc?.toString(), 
                    "et_body" : ApplicationState?.Body, 
                    "is_active" : ApplicationState?.Status,
                },
                "DeviceId" : device_id
            };
            if(LocationRoute === "update-mails") {
                param.url = "email_template_edit";
                param.request.email_template_id = CurrentData_?.id;
            } else {
                param.url = "email_template_add";
            };
            wsSend_request(websocket, param);
        } else {
            CheckValid(ApplicationState?.SubjectName.trim(), {type: 'SubjectName', error: seterrorSubjectName});
            CheckValid(SelectEvent, {type: 'SelectEvent', error: seterrorSelectEvent});
            CheckValid(ApplicationState?.To, {type: 'ToEmail', error: seterrorToEmail});
            CheckValid(ApplicationState?.Cc, {type: 'CcEmail', error: seterrorCcEmail});
            CheckValid(ApplicationState?.Body, {type: 'MailFormat', error: seterrorMailFormat});
        };
    };

    useEffect(() => {
        if(ClearFormSet?.action === 200 && (ClearFormSet?.url === "email_template_add" || ClearFormSet?.url === "email_template_edit")) {
            Navigate(ALL_MAIL_LISTING_URL);
        };
    }, [ ClearFormSet ]);

    return(<section className="createApplcation_wrapper">
        <div className="MainHeader">
            <Link to={ALL_MAIL_LISTING_URL} className="btn btn-link backbtn"><i className="bi bi-arrow-left-short"></i> Back</Link>
        </div>
        <CommonScrollBar height={{ height: "calc(100vh - 135px)"}}>
            <div className="tabsWrappers">
                <div className="formloginset">
                    <div className="mb-3" >
                        <label className="form-label">Subject<span className="mendatory_star">*</span></label>
                        <input
                            type="text" 
                            className="form-control"
                            value={ApplicationState?.SubjectName} 
                            onChange={(e) => setApplicationState({...ApplicationState, SubjectName: e.target.value})}
                            onKeyUp={(e) => CheckValid(e.target.value, {type: 'SubjectName', error: seterrorSubjectName})}
                            onKeyDown={EmptySpaceFieldValid}
                            placeholder="Enter Subject" 
                        />
                        {errorSubjectName !== "" && (<span className="error_medotory">{errorSubjectName}</span>)}
                    </div>
                    <div className="mb-3" >
                        <label className="form-label">Event<span className="mendatory_star">*</span></label>
                        <CommonReactSelectMenu 
                            label={"Event"}
                            options={EventOptions?.filter((elm) => elm?.is_active)} 
                            selectValue={SelectEvent} 
                            setSelectValue={setSelectEvent} 
                            dependantState={{
                                allow: false,
                            }} 
                            isMendatory={true}
                            errorState={errorSelectEvent} 
                            setErrorState={seterrorSelectEvent}
                            isAllowClearable={true}
                            customWidth={"100%"}
                            customeHeight={"38px"}
                            isMulti={false}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">To<span className="mendatory_star">*</span></label>
                        <div className="create-multi-emails-wraps">
                            <ReactMultiEmail
                                placeholder='Enter To'
                                emails={ApplicationState?.To}
                                onChange={(_emails) => onChangeToEmail(_emails, "to_email")}
                                autoFocus={true}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                                getLabel={(email, index, removeEmail) => {
                                    return (<div data-tag key={index}>
                                        <div data-tag-item>{email}</div>
                                        <span data-tag-handle onClick={() => removeEmail(index)}>
                                            ×
                                        </span>
                                    </div>);
                                }}
                            />
                        </div>
                        {errorToEmail !== "" && (<span className="error_medotory">{errorToEmail}</span>)}
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Cc<span className="mendatory_star">*</span></label>
                        <div className="create-multi-emails-wraps">
                            <ReactMultiEmail
                                placeholder='Enter CC'
                                emails={ApplicationState?.Cc}
                                onChange={(_emails) => onChangeToEmail(_emails, "cc_email")}
                                autoFocus={true}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                                getLabel={(email, index, removeEmail) => {
                                    return (<div data-tag key={index}>
                                        <div data-tag-item>{email}</div>
                                        <span data-tag-handle onClick={() => removeEmail(index)}>
                                            ×
                                        </span>
                                    </div>);
                                }}
                            />
                        </div>
                        {errorCcEmail !== "" && (<span className="error_medotory">{errorCcEmail}</span>)}
                    </div>
                    <div className="mb-3" >
                        <label className="form-label">Email Preview<span className="mendatory_star">*</span></label>
                        <div className="editorBox">
                            <ReactQuill 
                                formats={formats}
                                modules={modules}
                                theme="snow" 
                                value={ApplicationState?.Body} 
                                onChange={(data) => GetBodyEditor(data)} 
                                onKeyDown={(e) =>setTimeout(()=> ValueKeyPress(e), 10)}
                            />
                        </div>
                        {errorMailFormat !== "" && (<span className="error_medotory">{errorMailFormat}</span>)}
                    </div>
                    <div className="mb-3" >
                        <CommonToggle 
                            isBadgeAllow={true}
                            badgeTitle={"active_inactive"}
                            valueToggle={ApplicationState?.Status}
                            setValueToggle={() => setApplicationState({...ApplicationState, Status: !ApplicationState?.Status})}
                            name={"Status"}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button 
                                disabled={ClearFormSet?.action === true && (ClearFormSet?.url === "brand_add" || ClearFormSet?.url === "brand_edit")}
                                className="btn formbtn widthfullbtn" 
                                onClick={() => UpdateMailFunctions()} 
                            >
                                {LocationRoute === "update-mails" ? "Update" : "Create"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </CommonScrollBar>
    </section>)
}

export default UpdateMail;